"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTreeNodeSearch = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const debounce_1 = __importDefault(require("debounce"));
const product_tree_node_search_styles_1 = require("./product-tree-node-search.styles");
const search_result_block_1 = require("./search-result-block");
const attributes_1 = require("../../../../client/attributes");
const client_constants_1 = require("../../../../client/client.constants");
const product_tree_nodes_1 = require("../../../../client/product-tree-nodes");
const components_1 = require("../../../../components");
const generic_1 = require("../../../../generic");
const hooks_1 = require("../../../../hooks");
const localization_1 = require("../../../../../localization");
const store_1 = require("../../../../../store");
const ProductTreeNodeSearch = ({ selectedNodeTitle, onSelect, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [searchTerm, setSearchTerm] = (0, react_1.useState)('');
    const containerRef = (0, react_1.useRef)(null);
    const productTreeId = (0, store_1.useProductTreeId)();
    const currentSelectedTreeNode = (0, hooks_1.useSelectedTreeNode)();
    const { title: currentSelectedTreeNodeTitle } = currentSelectedTreeNode !== null && currentSelectedTreeNode !== void 0 ? currentSelectedTreeNode : {};
    const { getAllProductTreeNodes, data, error, isLoading, totalCount, pagination: { isLoadingMore, onNextPage, hasNextPage, }, } = (0, product_tree_nodes_1.useLazyProductTreeNodes)({
        productTreeId,
        filter: {
            terminalNodesOnly: true,
            title: {
                not: {
                    in: [currentSelectedTreeNodeTitle, attributes_1.UN_CATEGORIZED_NODE_TITLE],
                },
            },
        },
    });
    (0, react_1.useEffect)(() => {
        if (data.length > 0 && containerRef.current) {
            containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [data]);
    const lastElementRef = (0, hooks_1.useLoadMore)({
        moreItemsLoading: isLoadingMore,
        hasNextPage,
        onLoadMore: onNextPage,
    });
    const onSearchChanged = (0, react_1.useMemo)(() => (0, debounce_1.default)((search) => getAllProductTreeNodes({
        variables: {
            productTreeId,
            search,
            after: null,
        },
    }), client_constants_1.SEARCH_DELAY), [getAllProductTreeNodes, productTreeId]);
    const handleSearchChange = (e) => {
        const { value } = e.currentTarget;
        setSearchTerm(value);
        if (value.length >= client_constants_1.MIN_SEARCH_CHARACTERS_ALLOWED) {
            void onSearchChanged(value);
        }
    };
    const toggleSetToUnclassified = (event) => {
        const { checked } = event.target;
        onSelect(checked ? attributes_1.UN_CATEGORIZED_NODE_TITLE : undefined);
    };
    const lastElementIndex = data.length - 1;
    return (react_1.default.createElement(product_tree_node_search_styles_1.StyledProductTreeNodeSearch, null, react_1.default.createElement(product_tree_node_search_styles_1.StyledSearchInput, { onChange: handleSearchChange, value: searchTerm, placeholder: t({ key: 'SEARCH' }), startAdornment: react_1.default.createElement(material_1.InputAdornment, { position: "start" }, react_1.default.createElement(ui_components_1.Icon, { variant: "search", color: ui_components_1.baseColors.primaryBlueMed400, className: "search-icon" })), endAdornment: isLoading ? (react_1.default.createElement(generic_1.LoadingIndicator, null)) : (react_1.default.createElement(product_tree_node_search_styles_1.StyledInputAdornment, { position: "end" }, react_1.default.createElement(ui_components_1.Typography, { strong: true, variant: "body2" }, t({ key: 'SEARCH_FOR_NODES_COUNT', values: { count: data.length, total: totalCount } })), searchTerm.length > 0 && (react_1.default.createElement(material_1.IconButton, { size: 'small', onClick: () => setSearchTerm('') }, react_1.default.createElement(ui_components_1.Icon, { variant: "cancel", color: ui_components_1.baseColors.primaryBlueMed400 }))))) }), data.length > 0 && (react_1.default.createElement("div", { ref: containerRef, className: "product-tree-node-search-content" }, data.map(({ title, description }, index) => (react_1.default.createElement(search_result_block_1.SearchResultBlock, { ref: lastElementIndex === index ? lastElementRef : undefined, key: title, title: title, description: description, isSelected: selectedNodeTitle === title, searchText: searchTerm, onSelect: onSelect }))), isLoadingMore && react_1.default.createElement(generic_1.LoadingIndicator, { className: "load-more-indicator" }), error && react_1.default.createElement(components_1.Alert, { severity: "error" }, error.message))), currentSelectedTreeNodeTitle !== attributes_1.UN_CATEGORIZED_NODE_TITLE && (react_1.default.createElement(product_tree_node_search_styles_1.StyledFormControlLabel, { control: react_1.default.createElement(ui_components_1.Switch, { onChange: toggleSetToUnclassified, checked: selectedNodeTitle === attributes_1.UN_CATEGORIZED_NODE_TITLE }), label: react_1.default.createElement(ui_components_1.Typography, { accent: true, variant: "body1" }, t({ key: 'PRODUCT_RECLASSIFY_UNCATEGORIZED_LABEL' })) }))));
};
exports.ProductTreeNodeSearch = ProductTreeNodeSearch;
exports.default = exports.ProductTreeNodeSearch;
